import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../components/common";
import { pathConstants } from "../../../routes/pathContants";
import secondaryComponents from "../../../components/secondaryComponents";
import { useEffect } from "react";
import { useUrlSearch } from "../../../hooks/useUrlSearch";

export const PendingCheckoutHome = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();
  const { search, setSearch } = useUrlSearch();

  useEffect(() => {
    if (!search.get("store_id")) {
      search.set("store_id", search.get("store_id") || store_id);
      setSearch(search, { replace: true });
    }
  }, []);

  return (
    <RoutedModal
      isActive={true}
      headerTitle="Pending Checkouts"
      headerDescription="Manage your pending checkouts"
      closeModal={() =>
        navigate(pathConstants.SELL_MODE({ store_id: store_id }))
      }
    >
      <secondaryComponents.PendingCheckoutSessions />
    </RoutedModal>
  );
};
